import FilterBar from './FilterBar.jsx';

export default FilterBar;


// WEBPACK FOOTER //
// ./src/components/FilterBar/index.jsx